// __RAKVE_ONLY_USED_MARK
import React, { useEffect, useMemo, useRef, useState } from "react";

// --- RAKVE: seznam + skupiny (varianta B přes poznamka) ---
const __RAKEV_GROUP_LABELS = {
  celodrevene: "Celodřevěné",
  papirove: "Papírové",
  siroke: "Široké",
  dlouhe: "Dlouhé",
  detske: "Dětské",
  nezarazene: "Nezařazené",
};

function __getRakevList() {
  const src =
    (typeof CENIK !== "undefined" && CENIK) ? CENIK :
    (typeof CENIK_DBG !== "undefined" && CENIK_DBG) ? CENIK_DBG :
    [];
  const items = Array.isArray(src) ? src : Object.values(src || {});
  return items
    .filter(x => String((x && x.id) || "").startsWith("rakev_"))
    .map(x => ({
      id: String(x.id || ""),
      nazev: String(x.nazev || "Rakev"),
      cenaBezDph: Number(x.cenaBezDph || 0),
      dph: Number(x.dph ?? 12),
    }))
    .filter(x => x.id);
}

function __classifyRakevName(name) {
  const n = String(name || "").trim();
  const low = n.toLowerCase();

  // texty mají přednost
  if (low.includes("děts") || low.includes("dets")) return "detske";
  if (low.includes("sirok") || low.includes("širok")) return "siroke";
  if (low.includes("dlouh")) return "dlouhe";

  // prefixy/kódy
  if (/^(k\d+)/i.test(n) || /^pa/i.test(n)) return "celodrevene";
  if (/^er/i.test(n)) return "papirove";
  if (/^r/i.test(n)) return "nezarazene";

  return "nezarazene";
}

function __groupRakve(list) {
  const groups = {
    celodrevene: [],
    papirove: [],
    siroke: [],
    dlouhe: [],
    detske: [],
    nezarazene: [],
  };

  for (const r of (list || [])) {
    const key = __classifyRakevName(r?.nazev);
    (groups[key] || groups.nezarazene).push(r);
  }

  // sort: podle názvu (numeric), pak podle ceny
  for (const k of Object.keys(groups)) {
    groups[k].sort((a,b) =>
      String(a?.nazev || "").localeCompare(String(b?.nazev || ""), "cs", {numeric:true, sensitivity:"base"}) ||
      (Number(a?.cenaBezDph||0) - Number(b?.cenaBezDph||0))
    );
  }

  return groups;
}




// --- /RAKVE ---

import { RAKVE, KATEGORIE_RAKVI_ORDER } from "../data/rakve.js";
import { useFormData } from "../context/FormDataContext";
import { CENIK } from "../data/ceny";

const DPH_DEFAULT = 12;

// ===============================
// PAPÍR -> CENÍK (aliasy / mapování)
// (když ID v papíru neexistuje v ceníku, pořád se zobrazí jako papírová položka)
// ===============================
const PAPIR_TO_CENIK_ID = {
  nosici_osoby_hodiny: "nosic_osoba_hod",
  prevoz_jednoho_tela_cb_krematorium: "prevoz_tela_cb_krematorium_pausal",
  nositka: "transportni_nositka_vc_desinfekce",
  
pruvod: "pruvod_10min_hrbitov",
    pronajem_chladici_komora: "chladici_zarizeni_den",

  // PART 1 (left column)
  recnik: "civilni_recnik_v_sini",

  
katafalk: "katafalk_obradni_sin",
  pojizdny_katafalk: "pojizdny_katafalk",


    pronajem_kaple: "pronajem_kaple",
    pronajem_obradni_sin: "pronajem_obradni_sin",
  hra_na_varhany: "hra_na_varhany",
  pronajem_varhan: "pronajem_varhan",
  dechova_hudba: "dechova_hudba_od",

  videozaznam: "zaznam_z_obradu",

  online_prenos: "online_prenos",
  promitani_fotografii: "promitani_fotografii",

  obrad_s_urnou_zapujceni_urny: "obrad_s_urnou_zapujceni_urny",
  obrad_s_urnou_zapujceni_rakve: "obrad_s_urnou_zapujceni_rakve",

  // PART 2 (right column)
  holeni: "holeni",

  // paper: "Sjed. sm. obradu"
  sjednani_sm_obradu: "sjednani_obradu",
  sjednani_obradu: "sjednani_obradu",
  sjednani_obradu_online: "sjednani_obradu_online",
  sjednani_zpopelneni_bez_obradu: "sjednani_zpopelneni_bez_obradu",

  // transports flat
  prevoz_zesnuleho_pausal: "prevoz_ck_pausal",
  prevoz_zesnuleho: "prevoz_ck_pausal",
  prevoz_jednoho_tela_cb: "prevoz_tela_cb_krematorium_pausal",
  prevoz_jednoho_tela: "prevoz_tela_cb_krematorium_pausal",

  // waiting time
  cekaci_doba: "cekaci_doba_zapocata_hod",
  cekaci_doba_hod: "cekaci_doba_zapocata_hod",

  // handling
  manipulace_s_rakvi: "manipulace_rakvi_nositky",
  patra: "manipulace_rakvi_pat",

  // carriers / uniform
  nosici_pocet: "nosic_osoba_hod",
  nosici: "nosic_osoba_hod",
  pouz_stejnokroje: "stejnokroj_osoba",

  // display / staff / overhead
  vystaveni_zes: "vystaveni_zesnuleho",
  ukony_zamestnancu: "ukony_zamestnancu",

  rezie: "rezijni_naklady",
  rezie_bez_obradu: "rezijni_naklady_bez_obradu",

  rizeni_pohrebu: "rizeni_pohrebu",

  // extras
  dezinfekce_vozu: "dezinfekce_vozu",
  transportni_rakev: "transportni_rakev_vc_desinfekce",
  transportni_nositka: "transportni_nositka_vc_desinfekce",

  // urns
  otevreni_urny: "otevreni_a_zalepeni_urny",
  odsyp_popela: "odsyp_popela",
  ulozeni_urny: "ulozeni_urny_mesic",

  // zinc
  likvidace_zinku: "likvidace_zinkove_vlozky",
};

const _norm = (t) =>
  String(t || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const __CENIK_LIST_RAW = Array.isArray(CENIK) ? CENIK : Object.values(CENIK || {});

// ✅ Z ceníku vyhazujeme staré rakve (K400-1, K4000-1 atd.).
// Pozor: někdy je starý kód v id, někdy v nazev/label.
const __CENIK_LIST = (__CENIK_LIST_RAW || []).filter((x) => {
  const id = String(x?.id || "").trim();
  const kat = String(x?.kategorie || "").trim();
  const n = String(x?.nazev || x?.label || "").trim();

  // nové rakve necháme
  if (id.startsWith("rakev_") || kat === "rakve") return false;

  // staré označení vyhodit ať se nikdy neukáže v UI
  if (/^K\d{3,4}(-\d+)?$/i.test(n)) return false;
  if (/^K\d{3,4}(-\d+)?$/i.test(id)) return false;

  return true;
});

// ✅ Rakve-only seznam pro dropdown rakví (jen nové)
const __RAKVE_ONLY = (__CENIK_LIST || []).filter((x) => {
  const id = String(x?.id || "").trim();
  const kat = String(x?.kategorie || "").trim();
  return false;
});

function cenikGet(key, labelFallback = "") {
  if (!key) return null;

  // 1) přesné ID
  let hit = (__CENIK_LIST || []).find((x) => x && x.id === key);
  if (hit) return hit;

  // 2) alias z PAPIR_TO_CENIK_ID
  const alias = PAPIR_TO_CENIK_ID[key];
  if (alias) {
    hit = (__CENIK_LIST || []).find((x) => x && x.id === alias);
    if (hit) return hit;
  }

  // 3) fallback přes název (bez diakritiky)
  const want = _norm(labelFallback || key);
  if (!want) return null;
  return (__CENIK_LIST || []).find((x) => _norm(x?.nazev || x?.label || "") === want) || null;
}

const updateRow = (prev, id, patch) => {
  const arr = Array.isArray(prev) ? prev.slice() : [];
  const i = arr.findIndex((x) => x?.id === id);
  if (i < 0) return arr;

  const next = { ...arr[i], ...patch };

  // AUTO-ACTIVE: kdyz je qty > 0 nebo existuje cena/sub, radek se zapne
  const qty = Number(next.qty ?? next.mnozstvi ?? 0) || 0;
  const sub = Number(next.sub ?? 0) || 0;
  const fc = Number(next.fc ?? next.cenaJednBezDph ?? 0) || 0;

  if (qty > 0 || sub > 0 || fc > 0) next.active = true;

  arr[i] = next;
  return arr;
};

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const toNum = (v) => Number(String(v ?? "").replace(",", ".")) || 0;

// ===============================
// PAPÍROVÁ OBJEDNÁVKA – ŘÁDKY
// (1:1 jako papír, rozdělíme na Část 1 a Část 2)
// ===============================
const CAST1 = [
  { id: "recnik", label: "Řečník" },
  { id: "pronajem_kaple", label: "Pronájem - kaple" },
  { id: "pronajem_obradni_sin", label: "Pronájem - obřadní síň" },
  { id: "pronajem_chladici_komora", label: "Pronájem - chladící komora" },
  { id: "katafalk", label: "Katafalk" },
  { id: "pojizdny_katafalk", label: "Pojízdný katafalk" },
  { id: "hra_na_varhany", label: "Hra na varhany" },
  { id: "pronajem_varhan", label: "Pronájem varhan" },
  { id: "dechova_hudba", label: "Dechová hudba" },
  { id: "zpev", label: "Zpěv" },
  { id: "videozaznam", label: "Videozáznam" },
  { id: "autobus_sm_hosti", label: "Autobus pro smuteční hosty" },

  { id: "umrtni_oznameni", label: "Úmrtní oznámení" },
  { id: "vystaveni_vence_ks", label: "Vystavení věnce ks" },
  { id: "vystaveni_kytice_ks", label: "Vystavení kytice ks" },
  { id: "vence", label: "Věnce" },
  { id: "kytice", label: "Kytice" },
  { id: "stuhy", label: "Stuhy" },
  { id: "prani_objednavatele", label: "Přání objednavatele" },
  { id: "rozptyl", label: "Rozptyl" },
  { id: "kvetinova_vyzdoba", label: "Květinová výzdoba" },
  { id: "kremace", label: "Kremace" },
  { id: "rakev", label: "Rakev (cena)" },
  { id: "vlozka_zinek", label: "Vložka zinek - pozink" },
  { id: "souprava", label: "Souprava" },
  { id: "rubas", label: "Rubáš" },
  { id: "krajka", label: "Krajka" },
  { id: "poduska", label: "Poduška" },
  { id: "vak", label: "Vak" },
  { id: "svice", label: "Svíce kg - ks" },
  { id: "krizky", label: "Křížky" },
  { id: "provize", label: "Provize ze zajištěných služeb" },
];

const CAST2 = [
  { id: "letovani_vlozky", label: "Letování vložky" },
  { id: "umyvani_obleceni_ulozeni_ustrojeni", label: "Umývání, oblečení, uložení ustrojení" },
  { id: "holeni", label: "Holení" },
  { id: "sjednani_sm_obradu", label: "Sjed. sm. obřadu" },

  { id: "prevoz_zesnuleho_pausal", label: "Převoz zemřelého (paušál)" },
  { id: "prevoz_jednoho_tela_cb_krematorium", label: "Převoz jednoho těla do Č. B. Krematoria" },

  { id: "cekaci_doba", label: "Čekací doba (hod.)" },
  { id: "pruvod", label: "Průvod (min)" },
  { id: "manipulace_s_rakvi", label: "Manipulace s rakví" },
  { id: "patra", label: "Patra" },
  { id: "nosici_pocet", label: "Nosiči - počet" },
  { id: "pouz_stejnokroje", label: "Použ. stejnokroje" },
  { id: "vystaveni_zes", label: "Vystavení zes." },
  { id: "ukony_zamestnancu", label: "Za úkony zaměstnanců" },
  { id: "rizeni_pohrebu", label: "Řízení pohřbu" },
  { id: "nositka", label: "Nosítka" },
  { id: "telefony_telegramy", label: "Telefony - telegramy" },
  { id: "rezie", label: "Režie" },
    { id: "rezie_bez_obradu", label: "Režie bez obřadu" },
  { id: "uredni_urna", label: "Úřední urna" },
];

// ===============================

function makeRowFromCenik(id, label, cast) {
  const it = cenikGet(id, label);
  const cenaBez = toNum(it?.cenaBezDph ?? it?.cenaBezDPH ?? it?.cena ?? 0);
  const dphPct = toNum(it?.dph ?? it?.dphPct ?? DPH_DEFAULT) || DPH_DEFAULT;

  return {
    id: id, cenikId: (it?.id || id),
    nazev: it?.nazev || it?.label || label || id,
    jednotka: it?.jednotka || "",
    qty: it?.jednotka === "km" ? 0 : 1,
    fc: cenaBez,   // jednotková bez DPH z ceníku
    sub: 0,        // ruční přepis jednotkové ceny bez DPH
    dphPct,
    cast: cast || 1, // 1 nebo 2 (papír)
    custom: false,
  };
}

const effectiveSub = (row) => {
  const sub = Number(row?.sub ?? 0);
  if (Number.isFinite(sub) && sub > 0) return sub;
  const fc = Number(row?.fc ?? 0);
  if (Number.isFinite(fc) && fc > 0) return fc;
  return 0;
};

export default function VyberSluzebFormV2() {
  const { formData, setFormData, currentOrderId, saveOrder } = useFormData();

  
  // DEBUG_RAKEV_FORMDATA_OK: ověř, že se formData po výběru rakve mění
  // (v konzoli pak můžeš napsat window.__FD)
  useEffect(() => {
      try {
        window.__FD = formData;

        const fdRakevRow = Array.isArray(formData?.sluzby)
          ? formData.sluzby.find((x) => String(x?.id || "") === "rakev")
          : undefined;

        // logujeme jen to, co nás zajímá (a ne pokaždé celý formData)
        console.log("FD.rakve:", formData?.rakve, "FD.sluzby[rakev]:", fdRakevRow);
      } catch {}
    // méně spamu: log při změně zakázky + při změně vybrané rakve
    }, [currentOrderId, formData?.typRakve?.rakevId, formData?.rakve?.id, formData?.rakve?.rakevId]);
// ===============================
  // Persist + hydrate (služby)
  // ===============================
  const [saveInfo, setSaveInfo] = useState({ state: "idle", msg: "" });
  // ===============================
  // SOUPRAVA (barva + dovnitr/ven) -> formData.technicke.*
  // ===============================
  const [soupravaBarva, setSoupravaBarva] = useState(formData?.technicke?.soupravaBarva || "");
  const [soupravaUmisteni, setSoupravaUmisteni] = useState(formData?.technicke?.soupravaUmisteni || "dovnitr");

  // AUTOSYNC_FROM_FORMDATA_TECHN
  useEffect(() => {
    setSoupravaBarva(formData?.technicke?.soupravaBarva || "");
    setSoupravaUmisteni(formData?.technicke?.soupravaUmisteni || "dovnitr");
  }, [formData?.technicke?.soupravaBarva, formData?.technicke?.soupravaUmisteni]);

  const __syncSoupravaToFD = (patch) => {
    try {
      if (typeof setFormData !== "function") return;
      setFormData((prev) => ({
        ...(prev || {}),
        technicke: {
          ...((prev || {}).technicke || {}),
          ...(patch || {}),
        },
      }));
    } catch {}
  };

  const __clearSoupravaFD = () => {
    try {
      if (typeof setFormData !== "function") return;
      setFormData((prev) => {
        const next = { ...(prev || {}) };
        next.technicke = { ...(next.technicke || {}) };
        delete next.technicke.soupravaNazev;
        delete next.technicke.soupravaBarva;
        delete next.technicke.soupravaUmisteni;
        return next;
      });
    } catch {}
  };

  // hydratuj při změně zakázky / načtení dat
  useEffect(() => {
    try {
      setSoupravaBarva(formData?.technicke?.soupravaBarva || "");
      setSoupravaUmisteni(formData?.technicke?.soupravaUmisteni || "dovnitr");
    } catch {}
  }, [currentOrderId]);

  // detekce jestli je "souprava" vybraná (sel klíče se můžou lišit podle mapování ceníku)
  const __soupravaChecked = (() => {
    try {
      const keys = Object.keys(sel || {});
      return keys.some((k) => String(k || "").toLowerCase() === "souprava" || String(k || "").toLowerCase().includes("souprava"));
    } catch {
      return false;
    }
  })();

  // když uživatel soupravu odškrtne, vyčisti technicke.*
  useEffect(() => {
    if (!__soupravaChecked) {
      __clearSoupravaFD();
    }
  }, [__soupravaChecked]);
 // idle | saving | ok | err
  const __lastHydrateOrderId = useRef(null);

  const __buildSelFromSluzby = (arr) => {
    const out = {};
    const a = Array.isArray(arr) ? arr : [];
    for (const s of a) {
      if (!s?.id) continue;
      out[s.id] = {
        id: s.id,
        nazev: s.nazev || s.label || s.id,
        jednotka: s.jednotka || "",
        qty: toNum(s.mnozstvi ?? s.qty ?? 1) || 1,
        fc: toNum(s.fc ?? s.cenaJednBezDph ?? s.subBezDph ?? 0),
        sub: toNum(s.sub ?? 0),
        dphPct: toNum(s.dphPct ?? s.dph ?? DPH_DEFAULT) || DPH_DEFAULT,
        cast: toNum(s.cast) || 1,
        custom: !!s.custom,
          meta: (s && s.meta) ? s.meta : undefined,
          rakevId: (s && (s.rakevId || s?.meta?.rakevId)) ? String(s.rakevId || s?.meta?.rakevId) : undefined,
          qtyOsoby: (s.id === "nosic_osoba_hod" ? (toNum(s.qtyOsoby) || 1) : undefined),
          qtyHodiny: (s.id === "nosic_osoba_hod" ? (toNum(s.qtyHodiny) || 1) : undefined),
      };
    }
    return out;
  };

  // Když se otevře jiná zakázka (nebo se teprve načte formData), nahraj výběr služeb z contextu do lokálního sel
  useEffect(() => {
    if (!currentOrderId) return;
    if (__lastHydrateOrderId.current === currentOrderId) return;
    __lastHydrateOrderId.current = currentOrderId;
    setSel(__buildSelFromSluzby(formData?.sluzby));
    setSaveInfo({ state: "idle", msg: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrderId]);

  const __handleSaveSluzby = async () => {

    if (!currentOrderId) {
      setSaveInfo({ state: "err", msg: "Chybí ID zakázky (currentOrderId) – nejdřív založ/načti zakázku." });
      return;
    }

    try {
      if (typeof saveOrder !== "function") {
        setSaveInfo({ state: "err", msg: "Chybí saveOrder() v useFormData()" });
        return;
      }

      setSaveInfo({ state: "saving", msg: "Ukládám…" });

      const nextFormData = { ...(formData || {}), sluzby: sluzbyOut };
      if (typeof setFormData === "function") {
        setFormData(nextFormData);
      }

      const r = await saveOrder();
      const savedId = r?.meta?.id || r?.id || currentOrderId;

      if (savedId && savedId !== currentOrderId) {
        setSaveInfo({ state: "ok", msg: `Uloženo (pozor: backend vrátil jiné ID ${savedId})` });
      } else {
        setSaveInfo({ state: "ok", msg: "Uloženo ✓" });
      }

      setTimeout(() => setSaveInfo({ state: "idle", msg: "" }), 1800);
    } catch (e) {
      setSaveInfo({ state: "err", msg: String(e?.message || e || "Chyba uložení") });
    }
  };


  // ===============================
  
  // ===============================
  // ===============================
// CHLAZENI_ROW_V2 (AUTO split: 1-7 dnů od úmrtí = lednice, poté mrazák)
// - 7 dní se počítá OD ÚMRTÍ
// - start uložení může být později (např. až 6. den) => počítáme jen od startu
// - konec = datum+čas obřadu
// - AUTO lze ručně přepsat (pak se AUTO vypne)
// ===============================
const [coolOn, setCoolOn] = useState(false);
const [coolAuto, setCoolAuto] = useState(true);

const [coolCenaChlad, setCoolCenaChlad] = useState(0); // Kč/den bez DPH
const [coolCenaMraz, setCoolCenaMraz] = useState(0);   // Kč/den bez DPH

const [coolDnyChlad, setCoolDnyChlad] = useState(0);
const [coolDnyMraz, setCoolDnyMraz] = useState(0);

const [coolInfo, setCoolInfo] = useState({
  ok: false,
  death: "",
  start: "",
  end: "",
  dnyChlad: 0,
  dnyMraz: 0,
  note: "",
});

const _max0 = (v) => {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.floor(n));
};

const _coolSafeStr = (v) => String(v ?? "").trim();
const _coolSafeLower = (v) => _coolSafeStr(v).toLowerCase();
// --- datum/čas helpery (lokálně v bloku, aby nikdy nechyběly) ---
const _coolParseDate = (d) => {
  const t = _coolSafeStr(d);
  if (!t) return null;

  // yyyy-mm-dd
  let m = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (m) return { y: Number(m[1]), mo: Number(m[2]), da: Number(m[3]) };

  // dd.mm.yyyy
  m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (m) return { y: Number(m[3]), mo: Number(m[2]), da: Number(m[1]) };

  return null;
};

const _coolParseTime = (tm) => {
  const t = _coolSafeStr(tm);
  if (!t) return { h: 0, mi: 0 };
  const m = t.match(/^(\d{1,2})\s*:\s*(\d{1,2})/);
  if (!m) return { h: 0, mi: 0 };
  const h = Math.max(0, Math.min(23, Number(m[1] || 0)));
  const mi = Math.max(0, Math.min(59, Number(m[2] || 0)));
  return { h, mi };
};

const _coolMkDT = (dateStr, timeStr) => {
  const d = _coolParseDate(dateStr);
  if (!d) return null;
  const tm = _coolParseTime(timeStr);
  return new Date(d.y, d.mo - 1, d.da, tm.h, tm.mi, 0, 0);
};

const _coolFmtDT = (dt) => {
  if (!(dt instanceof Date) || isNaN(dt.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(dt.getDate())}.${pad(dt.getMonth() + 1)}.${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};
// --- /datum/čas helpery ---


const _coolPick = (arr) => {
  for (const v of (arr || [])) {
    const t = _coolSafeStr(v);
    if (t) return t;
  }
  return "";
};

// Wagnerka výjimka podle místa/adresy úmrtí
const _coolGetDeathPlaceText = (fd) => {
  const candidates = [
    fd?.mistoUmrti,
    fd?.adresaUmrti,
    fd?.misto_umrti,
    fd?.adresa_umrti,
    fd?.vstupniInformace?.mistoUmrti,
    fd?.vstupniInformace?.adresaUmrti,
    fd?.vstupniInformace?.misto_umrti,
    fd?.vstupniInformace?.adresa_umrti,
    fd?.vstupniInformace?.mistoUmrtiText,
    fd?.vstupniInformace?.adresaUmrtiText,
  ];
  for (const c of candidates) {
    const t = _coolSafeStr(c);
    if (t) return t;
  }
  return "";
};
const _coolIsWagnerkaDeath = (fd) => {
    const t = _coolSafeLower(_coolGetDeathPlaceText(fd));
    if (!t) return false;
    // bereme jen skutečné slovo "wagnerka" (aby to nechytalo náhodné části)
    return /(^|[^\p{L}])wagnerka([^\p{L}]|$)/iu.test(t);
  };

// ÚMRTÍ: datum+čas (robustně)
const _coolGetDeathDT = (fd) => {
  const date = _coolPick([
    fd?.datumUmrti,
    fd?.datum_umrti,
    fd?.vstupniInformace?.datumUmrti,
    fd?.vstupniInformace?.datum_umrti,
    fd?.zesnulaOsoba?.datumUmrti,
    fd?.zesnulaOsoba?.datum_umrti,
  ]);
  const time = _coolPick([
    fd?.casUmrti,
    fd?.cas_umrti,
    fd?.vstupniInformace?.casUmrti,
    fd?.vstupniInformace?.cas_umrti,
    fd?.zesnulaOsoba?.casUmrti,
    fd?.zesnulaOsoba?.cas_umrti,
  ]);
  // _coolMkDT je už v souboru výše (ty ho tam máš)
  return _coolMkDT(date, time);
};

// START: datum+čas "do chlazení" (více variant názvů)
const _coolGetStartDT = (fd) => {
  const date = _coolPick([
    fd?.datumDoChlazeni,
    fd?.datum_do_chlazeni,
    fd?.prevoz?.datumDoChlazeni,
    fd?.prevoz?.datum_do_chlazeni,
    fd?.vyjezd?.datumDoChlazeni,
    fd?.vyjezd?.datum_do_chlazeni,
    fd?.datumVyjezdu,
    fd?.datum_vyjezdu,
    fd?.vstupniInformace?.datumDoChlazeni,
    fd?.vstupniInformace?.datum_do_chlazeni,
      fd?.prevoz?.datumUlozeni,
      fd?.prevoz?.datum_ulozeni,
      fd?.prevoz?.datumUlozeniDoChlazeni,
      fd?.prevoz?.datum_ulozeni_do_chlazeni,
      fd?.vyjezd?.datumUlozeni,
      fd?.vyjezd?.datum_ulozeni,
      fd?.datumUlozeni,
      fd?.datum_ulozeni,
  ]);
  const time = _coolPick([
    fd?.casDoChlazeni,
    fd?.cas_do_chlazeni,
    fd?.prevoz?.casDoChlazeni,
    fd?.prevoz?.cas_do_chlazeni,
    fd?.vyjezd?.casDoChlazeni,
    fd?.vyjezd?.cas_do_chlazeni,
    fd?.casVyjezdu,
    fd?.cas_vyjezdu,
    fd?.vstupniInformace?.casDoChlazeni,
    fd?.vstupniInformace?.cas_do_chlazeni,
      fd?.prevoz?.casUlozeni,
      fd?.prevoz?.cas_ulozeni,
      fd?.prevoz?.casUlozeniDoChlazeni,
      fd?.prevoz?.cas_ulozeni_do_chlazeni,
      fd?.vyjezd?.casUlozeni,
      fd?.vyjezd?.cas_ulozeni,
      fd?.casUlozeni,
      fd?.cas_ulozeni,
  ]);
  return _coolMkDT(date, time);
};

// KONEC: obřad datum+čas
const _coolGetEndDT = (fd) => {
  const safe = _coolSafeStr;

  const pick = (...vals) => {
    for (const v of vals) {
      const x = safe(v).trim();
      if (x) return x;
    }
    return "";
  };

  const mk = (d, t) => {
    const dd = safe(d).trim();
    const tt = safe(t).trim();
    if (!dd) return null;
    const time = tt || "00:00";
    const dt = new Date(`${dd}T${time}`);
    return isNaN(dt.getTime()) ? null : dt;
  };

  // 1) PRIORITA: obřad datum + casDo
  const obradDatum = pick(
    fd?.obrad?.datum,
    fd?.obrad?.datumObradu,
    fd?.obrad?.datum_obradu,
    fd?.datumObradu,
    fd?.datum_obradu,
    fd?.kremacePohreb?.datumObradu,
    fd?.kremacePohreb?.datum_obradu,
    fd?.kremacePohreb?.obrad?.datumObradu,
    fd?.kremacePohreb?.obrad?.datum_obradu,
    fd?.kremacePohreb?.obradDatum,
    fd?.kremacePohreb?.obrad_datum
  );

  const obradCasDo = pick(
    fd?.obrad?.casDo,
    fd?.obrad?.cas_do,
    fd?.kremacePohreb?.casDo,
    fd?.kremacePohreb?.cas_do,
    fd?.kremacePohreb?.obrad?.casDo,
    fd?.kremacePohreb?.obrad?.cas_do,
    fd?.kremacePohreb?.obradCasDo,
    fd?.kremacePohreb?.obrad_cas_do
  );

  const dtCasDo = mk(obradDatum, obradCasDo);
  if (dtCasDo) return dtCasDo;

  // 2) fallback: rozloučení datum + čas
  const rozlDatum = pick(
    fd?.obrad?.datumRozlouceni,
    fd?.obrad?.datum_rozlouceni,
    fd?.datumRozlouceni,
    fd?.datum_rozlouceni,
    fd?.kremacePohreb?.datumRozlouceni,
    fd?.kremacePohreb?.datum_rozlouceni,
    fd?.kremacePohreb?.obrad?.datumRozlouceni,
    fd?.kremacePohreb?.obrad?.datum_rozlouceni,
    fd?.kalendar?.datumRozlouceni,
    fd?.kalendar?.datum_rozlouceni
  );

  const rozlCas = pick(
    fd?.obrad?.casRozlouceni,
    fd?.obrad?.cas_rozlouceni,
    fd?.casRozlouceni,
    fd?.cas_rozlouceni,
    fd?.kremacePohreb?.casRozlouceni,
    fd?.kremacePohreb?.cas_rozlouceni,
    fd?.kremacePohreb?.obrad?.casRozlouceni,
    fd?.kremacePohreb?.obrad?.cas_rozlouceni,
    fd?.kalendar?.casRozlouceni,
    fd?.kalendar?.cas_rozlouceni
  );

  const dtRozl = mk(rozlDatum, rozlCas);
  if (dtRozl) return dtRozl;

  // 3) fallback: obřad datum + (cas / casOd / casObradu)
  const obradCas = pick(
    fd?.obrad?.cas,
    fd?.obrad?.casOd,
    fd?.obrad?.casObradu,
    fd?.obrad?.cas_obradu,
    fd?.casObradu,
    fd?.cas_obradu,
    fd?.kremacePohreb?.casObradu,
    fd?.kremacePohreb?.cas_obradu,
    fd?.kremacePohreb?.obrad?.casObradu,
    fd?.kremacePohreb?.obrad?.cas_obradu,
    fd?.kremacePohreb?.obradCas,
    fd?.kremacePohreb?.obrad_cas,
    fd?.kremacePohreb?.obradCasOd,
    fd?.kremacePohreb?.obrad_cas_od
  );

  return mk(obradDatum, obradCas);
};


// ceny z ceníku
const _coolSyncCenyFromCenik = () => {
  const ch = Number(cenikGet("chladici_zarizeni_den", "chladici_zarizeni_den")?.cenaBezDph ?? 0) || 0;
  const mz = Number(cenikGet("mrazici_zarizeni_den", "mrazici_zarizeni_den")?.cenaBezDph ?? 0) || 0;
  setCoolCenaChlad(ch);
  setCoolCenaMraz(mz);
};



// [AUTO-REMOVED DUPLICATE COOLING GETTERS BLOCK]
const _coolRecalc = () => {
  const w = _coolIsWagnerkaDeath(formData);
  const end = _coolGetEndDT(formData);
  let start = _coolGetStartDT(formData);
  const death = _coolGetDeathDT(formData) || start;

  if (!end || isNaN(end.getTime())) {
    setCoolInfo({
      ok: false,
      death: death ? _coolFmtDT(death) : "",
      start: start ? _coolFmtDT(start) : "",
      end: "",
      dnyChlad: Number(coolDnyChlad || 0),
      dnyMraz: Number(coolDnyMraz || 0),
      note: "Chybí konec (obřad datum/čas)",
    });
    return;
  }

  // když není start (uložení), bereme ho jako úmrtí (uloženo hned)
  if (!start || isNaN(start.getTime())) start = death;

  if (!death || isNaN(death.getTime())) {
    setCoolInfo({
      ok: false,
      death: "",
      start: start ? _coolFmtDT(start) : "",
      end: _coolFmtDT(end),
      dnyChlad: Number(coolDnyChlad || 0),
      dnyMraz: Number(coolDnyMraz || 0),
      note: "Chybí datum/čas úmrtí",
    });
    return { dnyChlad: 0, dnyMraz: 0 };
}

  // pokud je start po end, nic
  if (start.getTime() >= end.getTime()) {
    setCoolOn(false);
    setCoolDnyChlad(0);
    setCoolDnyMraz(0);
    setCoolInfo({ ok: true, death: _coolFmtDT(death), start: _coolFmtDT(start), end: _coolFmtDT(end), dnyChlad: 0, dnyMraz: 0, note: "Start >= end" });
    return { dnyChlad: 0, dnyMraz: 0 };
}

  // hranice 7 dní od úmrtí (lednice do tohoto okamžiku), ale účtujeme od ULOŽENÍ
  const cut = new Date(death.getTime() + 7 * 24 * 60 * 60 * 1000);

  const minEndCut = new Date(Math.min(end.getTime(), cut.getTime()));
  const maxStartCut = new Date(Math.max(start.getTime(), cut.getTime()));

  const chladMs = Math.max(0, minEndCut.getTime() - start.getTime());        // ULOŽENÍ -> min(OBŘAD, ÚMRTÍ+7)
  const mrazMs  = Math.max(0, end.getTime() - maxStartCut.getTime());        // max(ULOŽENÍ, ÚMRTÍ+7) -> OBŘAD

  const dnyCh = chladMs > 0 ? Math.max(0, Math.ceil((chladMs / 36e5) / 24)) : 0;
  const dnyMz = mrazMs  > 0 ? Math.max(0, Math.ceil((mrazMs  / 36e5) / 24)) : 0;

  setCoolOn((dnyCh + dnyMz) > 0);
  setCoolDnyChlad(dnyCh);
  setCoolDnyMraz(dnyMz);

  setCoolInfo({
    ok: true,
    death: _coolFmtDT(death),
    start: _coolFmtDT(start),
    end: _coolFmtDT(end),
    dnyChlad: dnyCh,
    dnyMraz: dnyMz,
    note: w ? "AUTO split (7 dní od úmrtí) (Wagnerka)" : "AUTO split (7 dní od úmrtí)",
  });




  return { dnyChlad: dnyCh, dnyMraz: dnyMz };

};




  // ===============================
  // COOL AUTO EFFECT (single) - stabilní hooks, žádné nested useEffect
  // ===============================
  const _coolDeps = [
    _coolSafeStr(formData?.datumUmrti ?? formData?.datum_umrti ?? formData?.vstupniInformace?.datumUmrti ?? formData?.vstupniInformace?.datum_umrti ?? formData?.zesnulaOsoba?.datumUmrti ?? formData?.zesnulaOsoba?.datum_umrti),
    _coolSafeStr(formData?.casUmrti ?? formData?.cas_umrti ?? formData?.vstupniInformace?.casUmrti ?? formData?.vstupniInformace?.cas_umrti ?? formData?.zesnulaOsoba?.casUmrti ?? formData?.zesnulaOsoba?.cas_umrti),

    _coolSafeStr(formData?.datumDoChlazeni ?? formData?.datum_do_chlazeni ?? formData?.prevoz?.datumDoChlazeni ?? formData?.prevoz?.datum_do_chlazeni ?? formData?.vyjezd?.datumDoChlazeni ?? formData?.vyjezd?.datum_do_chlazeni ?? formData?.datumVyjezdu ?? formData?.datum_vyjezdu ?? formData?.datumUlozeni ?? formData?.datum_ulozeni ?? formData?.prevoz?.datumUlozeni ?? formData?.prevoz?.datum_ulozeni),
    _coolSafeStr(formData?.casDoChlazeni ?? formData?.cas_do_chlazeni ?? formData?.prevoz?.casDoChlazeni ?? formData?.prevoz?.cas_do_chlazeni ?? formData?.vyjezd?.casDoChlazeni ?? formData?.vyjezd?.cas_do_chlazeni ?? formData?.casVyjezdu ?? formData?.cas_vyjezdu ?? formData?.casUlozeni ?? formData?.cas_ulozeni ?? formData?.prevoz?.casUlozeni ?? formData?.prevoz?.cas_ulozeni),

    _coolSafeStr(formData?.obrad?.datumObradu ?? formData?.obrad?.datum_obradu ?? formData?.datumObradu ?? formData?.datum_obradu ?? formData?.kremacePohreb?.datumObradu ?? formData?.kremacePohreb?.datum_obradu ?? formData?.kremacePohreb?.obrad?.datumObradu ?? formData?.kremacePohreb?.obrad?.datum_obradu),
    _coolSafeStr(formData?.obrad?.casObradu ?? formData?.obrad?.cas_obradu ?? formData?.casObradu ?? formData?.cas_obradu ?? formData?.kremacePohreb?.casObradu ?? formData?.kremacePohreb?.cas_obradu ?? formData?.kremacePohreb?.obrad?.casObradu ?? formData?.kremacePohreb?.obrad?.cas_obradu),

      // ✅ obřad (nové klíče) – datum + konec (casDo) + případně cas
      // ✅ Kremace/Pohřeb (aliasy) – když se mění v téhle záložce, musí to přepočítat
      _coolSafeStr(formData?.kremacePohreb?.obradDatum ?? formData?.kremacePohreb?.obrad_datum),
      _coolSafeStr(formData?.kremacePohreb?.obradCas ?? formData?.kremacePohreb?.obrad_cas ?? formData?.kremacePohreb?.obradCasOd ?? formData?.kremacePohreb?.obrad_cas_od),
      _coolSafeStr(formData?.kremacePohreb?.obradCasDo ?? formData?.kremacePohreb?.obrad_cas_do),

      _coolSafeStr(formData?.obrad?.datum ?? formData?.obrad?.datumObradu ?? formData?.obrad?.datum_obradu),
      _coolSafeStr(formData?.obrad?.casDo ?? formData?.obrad?.cas_do ?? formData?.kremacePohreb?.casDo ?? formData?.kremacePohreb?.cas_do ?? formData?.kremacePohreb?.obrad?.casDo ?? formData?.kremacePohreb?.obrad?.cas_do),
      _coolSafeStr(formData?.obrad?.cas ?? formData?.obrad?.casOd ?? formData?.obrad?.casObradu ?? formData?.obrad?.cas_obradu),

    _coolSafeStr(formData?.mistoUmrti ?? formData?.adresaUmrti ?? formData?.misto_umrti ?? formData?.adresa_umrti ?? formData?.vstupniInformace?.mistoUmrti ?? formData?.vstupniInformace?.adresaUmrti ?? formData?.vstupniInformace?.misto_umrti ?? formData?.vstupniInformace?.adresa_umrti),
  
    // rozloučení / konec (alternativní názvy)
    _coolSafeStr(formData?.obrad?.datumRozlouceni ?? formData?.obrad?.datum_rozlouceni ?? formData?.datumRozlouceni ?? formData?.datum_rozlouceni),
    _coolSafeStr(formData?.obrad?.casRozlouceni ?? formData?.obrad?.cas_rozlouceni ?? formData?.casRozlouceni ?? formData?.cas_rozlouceni),

    _coolSafeStr(formData?.kremacePohreb?.datumRozlouceni ?? formData?.kremacePohreb?.datum_rozlouceni ?? formData?.kremacePohreb?.obrad?.datumRozlouceni ?? formData?.kremacePohreb?.obrad?.datum_rozlouceni),
    _coolSafeStr(formData?.kremacePohreb?.casRozlouceni ?? formData?.kremacePohreb?.cas_rozlouceni ?? formData?.kremacePohreb?.obrad?.casRozlouceni ?? formData?.kremacePohreb?.obrad?.cas_rozlouceni),

    _coolSafeStr(formData?.kalendar?.datumRozlouceni ?? formData?.kalendar?.datum_rozlouceni),
    _coolSafeStr(formData?.kalendar?.casRozlouceni ?? formData?.kalendar?.cas_rozlouceni),

].join("|");

  useEffect(() => {
    if (!coolAuto) return;

    // přepočet dnů do state
    const rr = _coolRecalc();
      const dnyCh = Number(rr?.dnyChlad || 0);
      const dnyMz = Number(rr?.dnyMraz || 0);
// propsání dnů do řádků služeb (jen když existují a jen když se liší)
    const chId = "chladici_zarizeni_den";
    const mzId = "mrazici_zarizeni_den";

    setFormData((prev) => {
      const cur = prev?.sluzby ?? [];
      if (!Array.isArray(cur) || cur.length === 0) return prev;

      let changed = false;
      const next = cur.map((r) => {
        const id = String(r?.id || r?.cenikId || "").trim();
        if (id === chId) {
          const nextQty = Number(dnyCh || 0);
          if (Number(r?.qty ?? 0) !== nextQty) changed = true;
          return { ...r, qty: nextQty };
        }
        if (id === mzId) {
          const nextQty = Number(dnyMz || 0);
          if (Number(r?.qty ?? 0) !== nextQty) changed = true;
          return { ...r, qty: nextQty };
        }
        return r;
      });

      if (!changed) return prev;
      return { ...prev, sluzby: next };
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coolAuto, coolDnyChlad, coolDnyMraz, _coolDeps]);
useEffect(() => {
  if (!coolAuto) return;
  _coolSyncCenyFromCenik();
  _coolRecalc();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [coolAuto, formData]);

// Zápis do sel => propsání do sluzbyOut
useEffect(() => {
  setSel((prev) => {
    const next = { ...(prev || {}) };

    // vypnuto => pryč obě položky
    if (!coolOn) {
      if (next["chladici_zarizeni_den"]) delete next["chladici_zarizeni_den"];
      if (next["mrazici_zarizeni_den"]) delete next["mrazici_zarizeni_den"];
      return next;
    }

    const w = _coolIsWagnerkaDeath(formData);
    const dCh = w ? 0 : (Number(coolDnyChlad || 0) || 0);
    const dMz = w ? 0 : (Number(coolDnyMraz || 0) || 0);

    const cCh = Number(coolCenaChlad || 0) || 0;
    const cMz = Number(coolCenaMraz || 0) || 0;

    // lednice
    if (dCh > 0 && cCh > 0) {
      next["chladici_zarizeni_den"] = {
        id: "chladici_zarizeni_den",
        nazev: "Chladící zařízení - 1 den",
        jednotka: "den",
        qty: dCh,
        fc: cCh,
        sub: 0,
        dphPct: DPH_DEFAULT,
        cast: 1,
        custom: false,
      };
    } else {
      if (next["chladici_zarizeni_den"]) delete next["chladici_zarizeni_den"];
    }

    // mrazák
    if (dMz > 0 && cMz > 0) {
      next["mrazici_zarizeni_den"] = {
        id: "mrazici_zarizeni_den",
        nazev: "Mrazící zařízení - 1 den",
        jednotka: "den",
        qty: dMz,
        fc: cMz,
        sub: 0,
        dphPct: DPH_DEFAULT,
        cast: 1,
        custom: false,
      };
    } else {
      if (next["mrazici_zarizeni_den"]) delete next["mrazici_zarizeni_den"];
    }

    return next;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [coolOn, coolDnyChlad, coolDnyMraz, coolCenaChlad, coolCenaMraz, formData]);

const coolRadekBez = (coolOn ? ((Number(coolCenaChlad || 0) * Number(coolDnyChlad || 0)) + (Number(coolCenaMraz || 0) * Number(coolDnyMraz || 0))) : 0);
// ===============================
// /CHLAZENI_ROW_V2
// ===============================
  // ===============================

  // ===============================



  const [activeCast, setActiveCast] = useState(1);

  // map id -> row (vybrané položky)
  const [sel, setSel] = useState(() => __buildSelFromSluzby(formData?.sluzby));

  // AUTOSYNC_FROM_FORMDATA_SLUZBY
  useEffect(() => {
    setSel(__buildSelFromSluzby(formData?.sluzby));
  }, [formData?.sluzby]);

  

  // Sync: když se načte jiná zakázka, přepočítej výběr služeb z formData.sluzby
  useEffect(() => {
    setSel(__buildSelFromSluzby(formData?.sluzby));
  }, [currentOrderId]);
  const floorKm = (v) => Math.max(0, Math.floor(Number(v || 0) || 0));

// === km z Převozu (robustně) ===
    // Billing km:
    //  - ZP: účtujeme jen km pro objednavatele (objednavatelKm)
    //  - Komerční: účtujeme totalKm
    const prevoz = formData?.prevoz || {};
    const rezimPrevoz = String(prevoz?.rezimZP ?? prevoz?.rezim ?? "").toLowerCase();
    const isZP = rezimPrevoz.includes("zp") || rezimPrevoz.includes("poj") || rezimPrevoz.includes("poji");

    const kmBill = isZP
      ? (prevoz?.objednavatelKm ?? prevoz?.kmObjednavatel ?? 0)
      : (prevoz?.totalKm ?? prevoz?.km ?? prevoz?.kmCalculated ?? 0);

    const kmBillFloor = Math.max(0, Math.floor(Number(kmBill || 0) || 0));

    const km = floorKm(toNum(kmBill ?? 0));
// === /KM z převozu ===
// === doprava z ceníku ===
  const dopravaCenik = cenikGet("doprava_1km", "Doprava rakve za 1 km");
  const dopravaJedn = toNum(dopravaCenik?.cenaBezDph ?? dopravaCenik?.cena ?? 30);
  const dopravaDphPct = toNum(dopravaCenik?.dph ?? dopravaCenik?.dphPct ?? DPH_DEFAULT) || DPH_DEFAULT;

  // Auto-přidání dopravy (můžeš ji odškrtnout)
  useEffect(() => {
    if (!km) return;
    setSel((prev) => {
      if (prev["doprava_1km"]) {
        return {
          ...prev,
          doprava_1km: {
            ...prev["doprava_1km"],
            qty: km,
            fc: prev["doprava_1km"].fc || dopravaJedn,
            dphPct: prev["doprava_1km"].dphPct || dopravaDphPct,
          },
        };
      }
      return {
        ...prev,
        doprava_1km: {
          id: "doprava_1km",
          nazev: "Doprava (km)",
          jednotka: "km",
          qty: km,
          fc: dopravaJedn,
          sub: 0,
          dphPct: dopravaDphPct,
          cast: 1,
          custom: false,
        },
      };
    });
  }, [km, dopravaJedn, dopravaDphPct]);

  // Převod do formData.sluzby (tvar kompatibilní s FinalniObjednavka)
  const sluzbyOut = useMemo(() => {
    const rows = Object.values(sel || {});

    // řazení: doprava první, pak cast 1, pak cast 2
    rows.sort((a, b) => {
      if (a.id === "doprava_1km") return -1;
      if (b.id === "doprava_1km") return 1;
      if ((a.cast || 1) !== (b.cast || 1)) return (a.cast || 1) - (b.cast || 1);
      return String(a.nazev || "").localeCompare(String(b.nazev || ""), "cs");
    });

    return rows.map((r) => {
      const qty = toNum(r.qty) || (r.id === "doprava_1km" ? 0 : 1);
      const subJedn = round2(effectiveSub(r));
      const bez = round2(subJedn * qty);
      const dphKc = round2((bez * (toNum(r.dphPct) || DPH_DEFAULT)) / 100);
      const sDph = round2(bez + dphKc);

      return {
        id: r.id,
        nazev: r.nazev,
        jednotka: r.jednotka || "",
        mnozstvi: qty,
        qty: qty,

        subBezDph: subJedn,
        cenaJednBezDph: subJedn,
        fc: toNum(r.fc) || 0,
        sub: toNum(r.sub) || 0,

        cenaBezDph: bez,
        bezDph: bez,
        dphPct: toNum(r.dphPct) || DPH_DEFAULT,
        dphKc: dphKc,
        sDph: sDph,
        cenaSDph: sDph,

        cast: toNum(r.cast) || 1,
        meta: (r && r.meta) ? r.meta : undefined,
          rakevId: (r && (r.rakevId || r?.meta?.rakevId)) ? String(r.rakevId || r?.meta?.rakevId) : undefined,
          custom: !!r.custom,
      };
    });
  }, [sel]);

  // Jediný zápis do contextu
  useEffect(() => {
    setFormData((prev) => ({ ...prev, sluzby: sluzbyOut }));
  }, [sluzbyOut, setFormData]);

  // Součty
  const sumBez = useMemo(() => sluzbyOut.reduce((a, r) => a + toNum(r.cenaBezDph), 0), [sluzbyOut]);
  const sumDph = useMemo(() => sluzbyOut.reduce((a, r) => a + toNum(r.dphKc), 0), [sluzbyOut]);
  const sumSDph = useMemo(() => sluzbyOut.reduce((a, r) => a + toNum(r.sDph), 0), [sluzbyOut]);

  const sumCast = (cast) => {
    const rows = sluzbyOut.filter((r) => toNum(r.cast) === cast && r.id !== "doprava_1km");
    const bez = round2(rows.reduce((a, r) => a + toNum(r.cenaBezDph), 0));
    const dph = round2(rows.reduce((a, r) => a + toNum(r.dphKc), 0));
    const sdph = round2(rows.reduce((a, r) => a + toNum(r.sDph), 0));
    return { bez, dph, sdph };
  };

  const cast1Totals = useMemo(() => sumCast(1), [sluzbyOut]);
  const cast2Totals = useMemo(() => sumCast(2), [sluzbyOut]);

  // Pomocné: pro zobrazení papíru v dané části
  const castRows = useMemo(() => (activeCast === 1 ? CAST1 : CAST2), [activeCast]);

  // Custom řádky v dané části (vybrané)
  const customInCast = useMemo(() => {
    return Object.values(sel || {}).filter((r) => r.custom && toNum(r.cast) === activeCast);
  }, [sel, activeCast]);

  const togglePapir = (idPapir, label, cast) => {
    const resolved = (cenikGet(idPapir, label)?.id) || PAPIR_TO_CENIK_ID[idPapir] || idPapir;

    setSel((prev) => {
      if (prev[resolved]) {
        const next = { ...prev };
        delete next[resolved];
        return next;
      }
      const row = makeRowFromCenik(resolved, label, cast);
      return { ...prev, [row.id]: row };
    });
  };

  const change = (id, patch) => {
    setSel((prev) => {
      const r = prev[id];
      if (!r) return prev;
      const nextRow = { ...r, ...patch };
      if (id === "nosic_osoba_hod") {
        const osoby = toNum(nextRow.qtyOsoby) || 0;
        const hodiny = toNum(nextRow.qtyHodiny) || 0;
        nextRow.qty = round2(osoby * hodiny);
      }
      return { ...prev, [id]: nextRow };
    });
  };

  const removeRow = (id) => {
    setSel((prev) => {
      if (!prev[id]) return prev;
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  const addCustomRow = (cast) => {
    const id = `custom_${Date.now()}`;
    setSel((prev) => ({
      ...prev,
      [id]: {
        id,
        nazev: "Vlastní položka",
        jednotka: "ks",
        qty: 1,
        fc: 0,
        sub: 0,
        dphPct: DPH_DEFAULT,
        cast,
        custom: true,
      },
    }));
  };

  const cardBtn = (on, label) => ({
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #ddd",
    background: on ? "#111" : "#fff",
    color: on ? "#fff" : "#111",
    fontWeight: 800,
    cursor: "pointer",
  });

  const th = { textAlign: "left", padding: 8, borderBottom: "1px solid #eee" };
  const td = { padding: 8, borderBottom: "1px solid #f2f2f2", verticalAlign: "middle" };
  const input = (w=90) => ({ width: w, padding: "6px 8px", borderRadius: 10, border: "1px solid #ddd" });

  

    // ===== RAKVE dropdown (pouze pro řádek "rakev") =====
    const rakevOptions = useMemo(() => {
      const order = Array.isArray(KATEGORIE_RAKVI_ORDER)
        ? KATEGORIE_RAKVI_ORDER
        : ["celodrevene","papirove","siroke","dlouhe","detske","nezarazene"];

      const idx = (k) => {
        const i = order.indexOf(String(k || ""));
        return i >= 0 ? i : 999;
      };

      return (RAKVE || [])
        .filter((x) => x?.typ === "rakev")
        .slice()
        .sort((a, b) => {
          const ka = idx(a?.kategorie);
          const kb = idx(b?.kategorie);
          if (ka !== kb) return ka - kb;
          return String(a?.nazev || "").localeCompare(String(b?.nazev || ""), "cs");
        });
    }, []);


    const rakevGroups = useMemo(() => {
      const groups = { celodrevene: [], papirove: [], siroke: [], dlouhe: [], detske: [], nezarazene: [] };
      (rakevOptions || []).forEach((r) => {
        const k = String(r?.kategorie || "celodrevene");
        if (!groups[k]) groups[k] = [];
        groups[k].push(r);
      });
      return groups;
    }, [rakevOptions]);
const currentRakevId = String(
      formData?.typRakve?.rakevId ||
      formData?.rakve?.id ||
      formData?.rakve?.rakevId ||
      // sluzby je ARRAY -> najdi meta.rakevId v položce "rakev"
      (Array.isArray(formData?.sluzby)
        ? (formData.sluzby.find((x) => String(x?.id || "") === "rakev")?.meta?.rakevId || "")
        : "") ||

      sel?.rakev?.meta?.rakevId ||
      sel?.rakev?.rakevId ||
      ""
    );
const onPickRakev = (rakevId) => {
      const r = (rakevOptions || []).find((x) => String(x.id) === String(rakevId));
      
          // ✅ uložím výběr i do formData.typRakve (persist)
          try {
            if (typeof setFormData === "function" && r) {
              setFormData((prev) => ({
                ...(prev || {}),
                typRakve: {
                  rakevId: String(r.id || ""),
                  nazev: String(r.nazev || ""),
                  cenaBezDph: r.cenaBezDph ?? r.cenaBezDPH ?? r.cenaBezDPH ?? null
                }
              }));
            }
          } catch {}
if (!r) return;

      // 1) uložíme do kontextu (pro dokumenty + finální objednávku)
      setFormData((prev) => ({
        ...prev,
        rakve: {
          ...(prev?.rakve || {}),
          id: r.id,
          typRakve: r.nazev,
            rakevId: String(r?.id || ""),
                    nazev: r.nazev,
          cenaBezDPH: r.cenaBezDph,
          cenaBezDph: r.cenaBezDph,
          cena: r.cenaBezDph,
          sazbaDPH: r.dph ?? 12,
          dph: r.dph ?? 12,
        },
      }));

      // ✅ udržuj meta o rakvi i v SEL (aby šlo přenést do sluzbyOut / formData.sluzby[])
      try {
        setSel((prevSel) => {
          const next = { ...(prevSel || {}) };
          const base = next["rakev"] || { id: "rakev", nazev: "Rakev (cena)", jednotka: "", qty: 1, fc: 0, sub: 0, dphPct: 12, cast: 1, custom: false };
          next["rakev"] = {
            ...base,
            id: "rakev",
            meta: {
              ...(base.meta || {}),
              rakevId: String(r?.id || ""),
              rakevKod: String(r?.kod || ""),
              rakevNazev: String(r?.nazev || ""),
            },
          };
          return next;
        });
      } catch {}

      // 2) nastavíme cenu přímo do řádku "rakev" v tabulce
      const bez = toNum(r.cenaBezDph) || 0;
      change("rakev", { sub: bez, fc: bez, qty: 1, dphPct: toNum(r.dph ?? 12) || 12 });
    };

  // ✅ držíme vybranou rakev i po re-renderu (select musí mít value)
  // hledáme v aktuálně vybraných službách položku s rakevId / id začínající "rakev_"
  const __SELECTED_RAKEV_ID = (() => {
    try {
      const obj = (typeof sluzby === "object" && sluzby) ? sluzby : {};
      const vals = Object.values(obj || {});
      for (const it of vals) {
        const rid = it?.rakevId || it?.id || "";
        if (String(rid).startsWith("rakev_")) return String(rid);
      }
      // fallbacky (kdyby se to ukládalo jinam)
      const f1 = (formData?.typRakve && (formData.typRakve.rakevId || formData.typRakve.id)) || "";
      const f2 = formData?.rakevId || "";
      return String(f1 || f2 || "");
    } catch {
      return "";
    }
  })();

const renderRow = (paper) => {
    const _resolved = (cenikGet(paper.id, paper.label)?.id) || PAPIR_TO_CENIK_ID[paper.id] || paper.id;
    const resolved = (paper.id === "rakev") ? "rakev" : _resolved;
    const st = sel[resolved];
    const checked = !!st;

    const jedn = checked ? effectiveSub(st) : toNum(cenikGet(resolved, paper.label)?.cenaBezDph ?? 0);
    const qty = checked ? toNum(st.qty) || 1 : 1;
    const bez = round2((checked ? jedn : jedn) * (checked ? qty : 0));
    return (
      <tr key={resolved}>
        <td style={td} align="center">
          <input
            type="checkbox"
            checked={checked}
            onChange={() => togglePapir(paper.id, paper.label, activeCast)}
          />
        </td>
        <td style={td}>
            {resolved === "rakev" && checked ? (
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <b>Rakev:</b>
                  <select
                    value={currentRakevId}
                    onChange={(e) => {
                      const id = String(e.target.value || "");
                      const list = (typeof __getRakevList === "function" ? (__getRakevList() || []) : []);

                      // CLEAR
                      if (!id) {
                        try { change("rakev", { sub: 0, fc: 0, qty: 1, dphPct: 12 }); } catch {}
                        try {
                          if (typeof setFormData === "function") {
                            setFormData((prev) => {
                              const next = { ...(prev || {}) };
                              next.rakve = { ...(next.rakve || {}), id: "", kod: "", typRakve: "", nazev: "", cenaBezDph: 0, cenaBezDPH: 0, sazbaDPH: 0, rakevId: "" };
                              // pokud máš sluzby jako objekt:
                              if (next.sluzby && typeof next.sluzby === "object" && !Array.isArray(next.sluzby)) {
                                try { delete next.sluzby["rakev"]; } catch {}
                              }
                              // pokud máš sluzby jako pole:
                              if (Array.isArray(next.sluzby)) {
                                next.sluzby = next.sluzby.filter((x) => String(x?.id || "") !== "rakev");
                              }
                              return next;
                            });
                          }
                        } catch {}
                        return;
                      }

                      const r = list.find((x) => String(x.id) === id);
                      if (!r) {
                        alert("Rakev nenalezena v __getRakevList() (zkontroluj src/data/rakve.js).");
                        return;
                      }

                      const __bez = Number(r.cenaBezDph ?? r.cenaBezDPH ?? 0) || 0;
                      const __dph = Number(r.dph ?? 12) || 12;

                      // ULOŽ DO formData
                      try {
                        if (typeof setFormData === "function") {
                          setFormData((prev) => {
                            const next = { ...(prev || {}) };

                            // rakve (Evidence chce název)
                            next.rakve = {
                              ...(next.rakve || {}),
                              id: String(r.id || ""),
                              rakevId: String(r.id || ""),
                              kod: String(r.kod || ""),
                              typRakve: String(r.nazev || ""),
                              nazev: String(r.nazev || ""),
                              cenaBezDph: __bez,
                              cenaBezDPH: __bez,
                              sazbaDPH: __dph,
                            };

                            // typRakve (persist)
                            next.typRakve = {
                              ...(next.typRakve || {}),
                              rakevId: String(r.id || ""),
                              nazev: String(r.nazev || ""),
                              cenaBezDph: __bez,
                            };

                            // sluzby: buď objekt nebo pole
                            if (next.sluzby && typeof next.sluzby === "object" && !Array.isArray(next.sluzby)) {
                              next.sluzby = { ...(next.sluzby || {}) };
                              next.sluzby["rakev"] = {
                                id: "rakev",
                                label: "Rakev",
                                qty: 1,
                                cenaBezDph: __bez,
                                dph: __dph,
                                meta: { rakevId: String(r.id || ""), rakevKod: String(r.kod || ""), rakevNazev: String(r.nazev || "") },
                              };
                            } else if (Array.isArray(next.sluzby)) {
                              const arr = next.sluzby.filter((x) => String(x?.id || "") !== "rakev");
                              arr.push({
                                id: "rakev",
                                label: "Rakev",
                                qty: 1,
                                cenaBezDph: __bez,
                                dph: __dph,
                                meta: { rakevId: String(r.id || ""), rakevKod: String(r.kod || ""), rakevNazev: String(r.nazev || "") },
                              });
                              next.sluzby = arr;
                            } else {
                              // když sluzby ještě neexistují, udělej objekt
                              next.sluzby = {
                                rakev: {
                                  id: "rakev",
                                  label: "Rakev",
                                  qty: 1,
                                  cenaBezDph: __bez,
                                  dph: __dph,
                                  meta: { rakevId: String(r.id || ""), rakevKod: String(r.kod || ""), rakevNazev: String(r.nazev || "") },
                                }
                              };
                            }

                            return next;
                          });
                        }
                      } catch {}

                      // Cena do řádku služby (tabulka)
                      try { change("rakev", { sub: __bez, fc: __bez, qty: 1, dphPct: __dph }); } catch {}
                    }}
                  >
                    <option value="">-- vyber typ rakve --</option>

                    {(() => {
                      const groups = __groupRakve(__getRakevList());
                      const order = ["celodrevene","papirove","siroke","dlouhe","detske","nezarazene"];

                      return order.map((key) => {
                        const arr = groups[key] || [];
                        if (!arr.length) return null;

                        return (
                          <optgroup key={key} label={__RAKEV_GROUP_LABELS[key] || key}>
                            {arr.map((r) => (
                              <option key={r.id} value={r.id}>
                                {r.nazev} ({r.cenaBezDph} Kč bez DPH)
                              </option>
                            ))}
                          </optgroup>
                        );
                      });
                    })()}

                  </select>
                </div>
              ) : resolved === "souprava" && checked ? (
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                  <b>Souprava:</b>

                  <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <span style={{ fontWeight: 800, color: "#444" }}>Barva</span>
                    <input
                      value={soupravaBarva}
                      onChange={(e) => {
                        const v = String(e.target.value || "");
                        setSoupravaBarva(v);
                        __syncSoupravaToFD({
                          soupravaNazev: "Souprava",
                          soupravaBarva: v,
                          soupravaUmisteni: soupravaUmisteni || "dovnitr",
                        });
                      }}
                      placeholder="např. bílá"
                      style={input(160)}
                    />
                  </label>

                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ fontWeight: 800, color: "#444" }}>Umístění</span>
                    <label style={{ display: "flex", gap: 6, alignItems: "center", fontWeight: 800 }}>
                      <input
                        type="radio"
                        name="souprava_umisteni"
                        checked={String(soupravaUmisteni || "dovnitr") === "dovnitr"}
                        onChange={() => {
                          setSoupravaUmisteni("dovnitr");
                          __syncSoupravaToFD({
                            soupravaNazev: "Souprava",
                            soupravaBarva: soupravaBarva || "",
                            soupravaUmisteni: "dovnitr",
                          });
                        }}
                      />
                      Dovnitř
                    </label>

                    <label style={{ display: "flex", gap: 6, alignItems: "center", fontWeight: 800 }}>
                      <input
                        type="radio"
                        name="souprava_umisteni"
                        checked={String(soupravaUmisteni || "") === "ven"}
                        onChange={() => {
                          setSoupravaUmisteni("ven");
                          __syncSoupravaToFD({
                            soupravaNazev: "Souprava",
                            soupravaBarva: soupravaBarva || "",
                            soupravaUmisteni: "ven",
                          });
                        }}
                      />
                      Ven
                    </label>
                  </div>
                </div>
              ) : (
                paper.label
              )}
</td>
        <td style={td} align="right">
          {checked ? (
            <input
              type="number"
              value={st?.sub > 0 ? st.sub : st?.fc || 0}
              onChange={(e) => {
                const v = toNum(e.target.value);
                change(resolved, { sub: v, fc: st?.fc || toNum(st?.fc) || 0 });
              }}
              style={input(110)}
            />
          ) : (
            round2(jedn)

            )}
        </td>
        <td style={td} align="right">
          {checked ? (
            <input
              type="number"
              value={st?.qty ?? 1}
              onChange={(e) => change(resolved, { qty: toNum(e.target.value) || 1 })}
              style={input(70)}
            />
          ) : (
            0

            )}
        </td>
        <td style={td} align="right">
          <b>{checked ? round2(effectiveSub(st) * (toNum(st.qty) || 1)) : 0}</b>
        </td>
      </tr>
    );
  };

  const renderCustom = (r) => {
    const id = r.id;
    const jedn = effectiveSub(r);
    const qty = toNum(r.qty) || 1;
    const bez = round2(jedn * qty);

    return (
      <tr key={id}>
        <td style={td} align="center">★</td>
        <td style={td}>
          <input
            value={r.nazev || ""}
            onChange={(e) => change(id, { nazev: e.target.value })}
            style={input(260)}
          />
        </td>
        <td style={td} align="right">
          <input
            type="number"
            value={r.sub > 0 ? r.sub : r.fc}
            onChange={(e) => change(id, { sub: toNum(e.target.value) })}
            style={input(110)}
          />
        </td>
        <td style={td} align="right">
          <input
            type="number"
            value={r.qty ?? 1}
            onChange={(e) => change(id, { qty: toNum(e.target.value) || 1 })}
            style={input(70)}
          />
        </td>
        <td style={td} align="right">
          <b>{bez}</b>
          <button
            onClick={() => removeRow(id)}
            style={{ marginLeft: 8, padding: "4px 8px", borderRadius: 10, border: "1px solid #ddd", cursor: "pointer" }}
            title="Smazat řádek"
          >
            ✕
          </button>
        </td>
      </tr>
    );
  };

  const castTotals = activeCast === 1 ? cast1Totals : cast2Totals;


  const [sluzbyQuery, setSluzbyQuery] = useState("");
  const [jenVybrane, setJenVybrane] = useState(false);

  const __q = String(sluzbyQuery || "").trim().toLowerCase();

  const __matchText = (txt) => {
    if (!__q) return true;
    return String(txt || "").toLowerCase().includes(__q);
  };

  const __resolvedId = (paper) => {
    const pid = paper?.id;
    const label = paper?.label;
    return (cenikGet(pid, label)?.id) || PAPIR_TO_CENIK_ID[pid] || pid;
  };

  const __showPaper = (paper) => {
    // 1) search podle label/id
    const txt = `${paper?.label || ""} ${paper?.id || ""}`;
    if (!__matchText(txt)) return false;

    // 2) jen vybrané
    if (jenVybrane) {
      const rid = __resolvedId(paper);
      return !!sel?.[rid];
    }
    return true;
  };

  const __showCustom = (row) => {
    // custom řádky jsou vždy "vybrané", protože existují v sel
    if (!__matchText(row?.nazev || "")) return false;
    if (jenVybrane) return true;
    return true;
  };

  const __showDopravaBlock = () => {
    // default: vždy zobrazit
    if (!__q && !jenVybrane) return true;
    return true;
  };
  return (
    <div style={{ padding: 16, maxWidth: 1100, margin: "0 auto" }}>
      {/* Header jako ve Výjezdech */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 900 }}>Výběr služeb</div>

        <div style={{ marginLeft: "auto", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ color: "#555", fontWeight: 800 }}>
            DPH: {DPH_DEFAULT}% &nbsp;|&nbsp; Km z převozu: <b>{kmBillFloor || 0}</b>
              <span style={{ marginLeft: 12 }} />
              <button
                onClick={__handleSaveSluzby}
                disabled={saveInfo.state === "saving"}
                style={{
                  padding: "8px 12px",
                  borderRadius: 12,
                  border: "1px solid #ddd",
                  background: saveInfo.state === "saving" ? "#f3f3f3" : "white",
                  cursor: saveInfo.state === "saving" ? "not-allowed" : "pointer",
                  fontWeight: 900
                }}
                title="Uloží výběr služeb do zakázky (knihyApiUlozit)"
              >
                {saveInfo.state === "saving" ? "Ukládám…" : "Uložit služby"}
              </button>
              {saveInfo.msg ? (
                <span style={{ marginLeft: 10, fontWeight: 900, color: saveInfo.state === "err" ? "#b00020" : "#1b5e20" }}>
                  {saveInfo.msg}
                </span>
              ) : null}

          </div>
        </div>

      </div>

      {/* Ovládací lišta jako ve Výjezdech */}
      <div style={{
        border: "1px solid #eee",
        borderRadius: 14,
        padding: 12,
        marginBottom: 12,
        display: "flex",
        gap: 10,
        alignItems: "center",
        flexWrap: "wrap"
      }}>
        <button style={cardBtn(activeCast === 1, "Část 1")} onClick={() => setActiveCast(1)}>
          Část 1
        </button>
        <button style={cardBtn(activeCast === 2, "Část 2")} onClick={() => setActiveCast(2)}>
          Část 2
        </button>

        <div style={{ marginLeft: "auto", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <input
            value={sluzbyQuery}
            onChange={(e) => setSluzbyQuery(e.target.value)}
            placeholder="Hledat službu…"
            style={{
              padding: "8px 10px",
              borderRadius: 12,
              border: "1px solid #ddd",
              minWidth: 220,
              fontWeight: 700
            }}
          />

          <label style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 800, color: "#333" }}>
            <input
              type="checkbox"
              checked={jenVybrane}
              onChange={(e) => setJenVybrane(e.target.checked)}
            />
            Jen vybrané
          </label>
        </div>
        </div>

        {(
          (!String(sluzbyQuery || "").trim() ||
            "doprava doprava (km) km doprava_1km".includes(String(sluzbyQuery || "").trim().toLowerCase())) &&
          (!jenVybrane || !!sel?.["doprava_1km"])
        ) && (
      <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 12, marginBottom: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 8 }}>Doprava (km)</div>
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input
              type="checkbox"
              checked={!!sel["doprava_1km"]}
              onChange={() => {
                setSel((prev) => {
                  if (prev["doprava_1km"]) {
                    const next = { ...prev };
                    delete next["doprava_1km"];
                    return next;
                  }
                  return {
                    ...prev,
                    doprava_1km: {
                      id: "doprava_1km",
                      nazev: "Doprava (km)",
                      jednotka: "km",
                      qty: km || 0,
                      fc: dopravaJedn,
                      sub: 0,
                      dphPct: dopravaDphPct,
                      cast: 1,
                      custom: false,
                    },
                  };
                });
              }}
            />
            Zapnout dopravu
          </label>

          <div>Jedn. bez DPH: <b>{round2(dopravaJedn)}</b></div>
          <div>Km: <b>{km || 0}</b></div>
          <div>Řádek bez DPH: <b>{round2((km || 0) * dopravaJedn)}</b></div>

        {/* CHLAZENI_ROW_V2_UI */}
<div style={{ marginTop: 10, padding: 10, border: "1px solid #ddd", borderRadius: 10 }}>
  <div style={{ fontWeight: 800, marginBottom: 6 }}>🧊 Chlazení / Mražení (AUTO split)</div>

  <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center" }}>
    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <input
        type="checkbox"
        checked={!!coolOn}
        onChange={(e) => setCoolOn(!!e.target.checked)}
      />
      <span style={{ fontWeight: 700 }}>Zapnout chlazení</span>
    </label>

    <button
      type="button"
      onClick={() => { setCoolAuto(true); _coolSyncCenyFromCenik(); _coolRecalc(); }}
      style={{ border: "1px solid #ccc", borderRadius: 10, padding: "6px 10px", fontWeight: 800 }}
      title="Přepočítat automaticky (ceny + dny)"
      disabled={!coolOn}
    >
      ♻️ AUTO
    </button>

    <div style={{ fontSize: 12, opacity: 0.75 }}>
      {coolInfo?.ok ? (
          <>
            {coolInfo.note}
            {( (coolInfo?.wagnerka) || String(coolInfo?.note || "").toLowerCase().includes("wagnerka") ) ? (
              <span
                title={"Wagnerka: prvních 48 hodin od uložení se neúčtuje. Poté se doba rozdělí na lednici (max 7 dní od úmrtí) a mrazák."}
                style={{ marginLeft: 8, cursor: "help", fontWeight: 700 }}
              >
                ⓘ
              </span>
            ) : null}
            {`: Úmrtí ${coolInfo.death} | Uložení ${coolInfo.start} → Obřad ${coolInfo.end}`}
          </>
        ) : (
          (coolInfo?.note || "AUTO")
        )}</div>
  </div>

  <div style={{ display: "flex", flexWrap: "wrap", gap: 14, alignItems: "center", marginTop: 10 }}>
    {/* LEDNICE */}
    <div style={{ display: "flex", gap: 8, alignItems: "center", padding: 8, border: "1px solid #eee", borderRadius: 10 }}>
      <b>Lednice</b>
      <span style={{ opacity: 0.8 }}>Kč/den bez DPH:</span>
      <input
        type="number"
        min={0}
        step="1"
        value={Number(coolCenaChlad ?? 0)}
        onChange={(e) => { setCoolAuto(false); setCoolCenaChlad(_max0(e.target.value)); }}
        style={{ width: 90, border: "1px solid #ccc", borderRadius: 10, padding: "6px 10px" }}
        disabled={!coolOn}
      />
      <span style={{ opacity: 0.8 }}>Dní:</span>
      <input
        type="number"
        min={0}
        step="1"
        value={Number(coolDnyChlad ?? 0)}
        onChange={(e) => { setCoolAuto(false); setCoolDnyChlad(_max0(e.target.value)); }}
        style={{ width: 70, border: "1px solid #ccc", borderRadius: 10, padding: "6px 10px" }}
        disabled={!coolOn}
      />
      <span style={{ opacity: 0.8 }}>Řádek bez DPH:</span>
      <b>{Number((Number(coolCenaChlad||0) * Number(coolDnyChlad||0)) || 0).toLocaleString("cs-CZ")}</b>
    </div>

    {/* MRAZÁK */}
    <div style={{ display: "flex", gap: 8, alignItems: "center", padding: 8, border: "1px solid #eee", borderRadius: 10 }}>
      <b>Mrazák</b>
      <span style={{ opacity: 0.8 }}>Kč/den bez DPH:</span>
      <input
        type="number"
        min={0}
        step="1"
        value={Number(coolCenaMraz ?? 0)}
        onChange={(e) => { setCoolAuto(false); setCoolCenaMraz(_max0(e.target.value)); }}
        style={{ width: 90, border: "1px solid #ccc", borderRadius: 10, padding: "6px 10px" }}
        disabled={!coolOn}
      />
      <span style={{ opacity: 0.8 }}>Dní:</span>
      <input
        type="number"
        min={0}
        step="1"
        value={Number(coolDnyMraz ?? 0)}
        onChange={(e) => { setCoolAuto(false); setCoolDnyMraz(_max0(e.target.value)); }}
        style={{ width: 70, border: "1px solid #ccc", borderRadius: 10, padding: "6px 10px" }}
        disabled={!coolOn}
      />
      <span style={{ opacity: 0.8 }}>Řádek bez DPH:</span>
      <b>{Number((Number(coolCenaMraz||0) * Number(coolDnyMraz||0)) || 0).toLocaleString("cs-CZ")}</b>
    </div>

    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <span style={{ opacity: 0.8 }}>Celkem bez DPH:</span>
      <b>{Number(coolRadekBez || 0).toLocaleString("cs-CZ")}</b>
      <span style={{ fontSize: 12, opacity: 0.7 }}>
        {coolAuto ? "(AUTO)" : "(ručně upraveno)"}
      </span>
    </div>
  </div>

  <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>
    Pravidlo: Lednice max 7 dní od úmrtí. Pokud se uloží až 6. den, lednice se počítá jen od uložení (např. 1 den) a zbytek do obřadu je mrazák.
  </div>
</div>
{/* /CHLAZENI_ROW_V2_UI */}
        </div>
      </div>
        )}


      {/* Aktivní část (cihla) */}
      <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 12 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <div style={{ fontWeight: 900, fontSize: 16 }}>
            {activeCast === 1 ? "Část 1 (levý sloupec papíru)" : "Část 2 (pravý sloupec papíru)"}
          </div>

          <div style={{ marginLeft: "auto", color: "#555", fontWeight: 800 }}>
            Součet části bez DPH: <b>{castTotals.bez}</b> Kč &nbsp;|&nbsp;
            DPH: <b>{castTotals.dph}</b> Kč &nbsp;|&nbsp;
            S DPH: <b>{castTotals.sdph}</b> Kč
          </div>
        </div>

        <table width="100%" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ ...th, width: 50 }}>✓</th>
              <th style={th}>Název</th>
              <th style={{ ...th, width: 140, textAlign: "right" }}>Jedn. bez DPH</th>
              <th style={{ ...th, width: 90, textAlign: "right" }}>Množ.</th>
              <th style={{ ...th, width: 160, textAlign: "right" }}>Řádek bez DPH</th>
            </tr>
          </thead>
          <tbody>
            {castRows.filter(__showPaper).map(renderRow)}
            {customInCast.filter(__showCustom).map(renderCustom)}
          </tbody>
        </table>

        {/* + tlačítko v obou částech */}
        <div style={{ marginTop: 12, display: "flex", gap: 10, justifyContent: "space-between", flexWrap: "wrap" }}>
          <button
            onClick={() => addCustomRow(activeCast)}
            style={{
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid #ddd",
              background: "#fff",
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            + Přidat vlastní řádek (Část {activeCast})
          </button>

          <div style={{ color: "#666", fontWeight: 700 }}>
            Celkem služby bez DPH: <b>{round2(sumBez)}</b> Kč &nbsp;|&nbsp;
            DPH: <b>{round2(sumDph)}</b> Kč &nbsp;|&nbsp;
            Celkem s DPH: <b>{round2(sumSDph)}</b> Kč
          </div>
        </div>
      </div>
    </div>
  );
}
